<template>
  <div class="po-payment">
    <b-row>
      <b-col>
        <b-form-group :disabled="!editable">
          <label>Tiền mặt</label>
          <b-form-input
            class="input-style text-right"
            size="sm"
            type="text"
            v-model="mainModel.cashAmount"
            placeholder="Nhập số tiền mặt"
            v-mask="currency"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group :disabled="!editable">
          <label>Tài khoản tiền mặt:</label>
          <Autosuggest
            class="border-radius-none"
            :model="mainModel.cashAccountName"
            :suggestions="filteredCashAcc"
            placeholder="tài khoản tiền mặt"
            :limit="10"
            @select="onSelectedCashAcc"
            @change="onInputChangeCashAcc"
            suggestionName="suggestionName"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group :disabled="!editable">
          <label>Tiền chuyển khoản</label>
          <b-form-input
            class="input-style text-right"
            size="sm"
            type="text"
            v-model="mainModel.transferAmount"
            placeholder="Nhập số tiền"
            v-mask="currency"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group :disabled="!editable">
          <label>Tài khoản chuyển khoản:</label>
          <Autosuggest
            class="border-radius-none"
            :model="mainModel.transferAccountName"
            :suggestions="filteredTransferAcc"
            placeholder="tài khoản chuyển khoản"
            :limit="10"
            @select="onSelectedTransferAcc"
            @change="onInputChangeTransferAcc"
            suggestionName="suggestionName"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group :label="'Ngày thanh toán'" :disabled="!editable">
          <date-picker
            placeholder="Chọn ngày thanh toán"
            class="mb-2 form-control form-control-sm"
            :config="dpConfigs.date"
            v-model="mainModel.payDate"
          ></date-picker>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { currencyMask, unMaskPrice, xoa_dau } from './../../../utils/common';
import timeUtils from '@/utils/date';
import datePicker from 'vue-bootstrap-datetimepicker';
import ApiService from '@/core/services/api.service';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';

export default {
  // TK tiền mặt/CK luôn lấy theo type (getByType), không lọc theo kho.
  props: {
    editable: { type: Boolean, default: false },
    mainModel: { type: Object, required: true },
  },
  components: { datePicker, Autosuggest },
  data() {
    return {
      currency: currencyMask,
      dpConfigs: timeUtils.DP_CONFIG,
      optionsCashAcc: [],
      filteredCashAcc: [],
      optionsTransferAcc: [],
      filteredTransferAcc: [],
    };
  },
  computed: {
    hasCash() {
      return Number(unMaskPrice(this.mainModel.cashAmount)) > 0;
    },
    hasTransfer() {
      return Number(unMaskPrice(this.mainModel.transferAmount)) > 0;
    },
  },
  watch: {
    // Re-resolve tên hiển thị khi id hoặc danh sách options thay đổi (tránh race lúc hydrate).
    'mainModel.cashAccountId'() {
      this._resolveCashName();
    },
    'mainModel.transferAccountId'() {
      this._resolveTransferName();
    },
    optionsCashAcc() {
      this._resolveCashName();
    },
    optionsTransferAcc() {
      this._resolveTransferName();
    },
  },
  created() {
    this.fetchCashAccounts();
    this.fetchTransferAccounts();
  },
  methods: {
    async _fetchAccounts(type) {
      try {
        const res = await ApiService.query('accountants/getByType', {
          params: { type },
        });
        const list = res.data.data || [];
        return list.map((a) => ({
          id: a.id,
          name: a.name,
          code: a.code,
          suggestionName: a.name,
        }));
      } catch {
        return [];
      }
    },
    async fetchCashAccounts() {
      this.optionsCashAcc = await this._fetchAccounts('CASH');
      this.filteredCashAcc = [...this.optionsCashAcc];
      this._resolveCashName();
    },
    async fetchTransferAccounts() {
      this.optionsTransferAcc = await this._fetchAccounts('TRANSFER');
      this.filteredTransferAcc = [...this.optionsTransferAcc];
      this._resolveTransferName();
    },
    // Resolve tên hiển thị khi PO đã hydrate id trước lúc list về.
    _resolveCashName() {
      if (!this.mainModel.cashAccountId) return;
      const acc = this.optionsCashAcc.find(
        (a) => a.id === this.mainModel.cashAccountId,
      );
      if (acc) this.mainModel.cashAccountName = acc.name;
    },
    _resolveTransferName() {
      if (!this.mainModel.transferAccountId) return;
      const acc = this.optionsTransferAcc.find(
        (a) => a.id === this.mainModel.transferAccountId,
      );
      if (acc) this.mainModel.transferAccountName = acc.name;
    },
    onSelectedCashAcc(option) {
      this.mainModel.cashAccountName = option.item.name;
      this.mainModel.cashAccountId = option.item.id;
      this.mainModel.cashAccountCode = option.item.code;
    },
    onInputChangeCashAcc(text) {
      this.mainModel.cashAccountName = text;
      if (!text) {
        this.mainModel.cashAccountId = null;
        this.mainModel.cashAccountCode = null;
      }
      this.filteredCashAcc = this.optionsCashAcc
        .filter((a) => {
          const noSign = xoa_dau(a.name);
          return (
            a.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            noSign.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, 10);
    },
    onSelectedTransferAcc(option) {
      this.mainModel.transferAccountName = option.item.name;
      this.mainModel.transferAccountId = option.item.id;
      this.mainModel.transferAccountCode = option.item.code;
    },
    onInputChangeTransferAcc(text) {
      this.mainModel.transferAccountName = text;
      if (!text) {
        this.mainModel.transferAccountId = null;
        this.mainModel.transferAccountCode = null;
      }
      this.filteredTransferAcc = this.optionsTransferAcc
        .filter((a) => {
          const noSign = xoa_dau(a.name);
          return (
            a.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            noSign.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, 10);
    },
  },
};
</script>
